import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import PaymentServices from "./PaymentServices";

export default function ViewUploadFileLogBox(param: any) {
    console.log(param)

    const [openFirst, setOpenFirst] = useState(false);

    const returnValue = (e: any) => {
        param.onChange(e)
        setOpenFirst(false)
    }

    let [viewUploadLog, setViewUplodLog] = useState<any>([]);
    const ViewUploadFileLog = () => {
        var payload = { pageNumner: 1, pageSize: 1, sourec: 'none' }
        PaymentServices.ViewUploadFileLog(payload).then((res: any) => {
            console.log(res)
            viewUploadLog = res
            setViewUplodLog(res)
            console.log("File History button test")
        })
    }

    useEffect(() => {
        ViewUploadFileLog()
    }, [param.param])


    return (
        <div className="ws-6">
            <Modal open={param.param} onClose={() => returnValue(2)} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-5 paddingCenterBox bgTransparent' }} >

                <div className="row-fluid sortable box">

                    <div className="modal-header">
                        <div className="box-header-main">
                            <h2 className="ws-10 ">View Upload File Log</h2>
                            <div className="toolbox">
                                <button title="Reload File Log" className="btn icon-btn delete pull-right" data-ng-click="init()"><i className="icon-reload"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="box-content">
                        <div className="form-horizontal  form-condensed clearfix">
                            <div className="row-fluid">
                                <div className="ws-5">
                                    <div className="form-format">
                                        <label className="control-label ">Filename</label>
                                        <div className="label-entries ws-12">
                                            <input type="text" className="ws-12 pLarge form-control " placeholder="Enter Filename" ng-model="filename" id="filename" />
                                        </div>
                                    </div>
                                </div>

                                <div className="ws-3">
                                    <a href="javascript: void(0);" className="btn icon-btn edit " data-ng-click="getFileLogListing(filename)"><i className="icon-search"></i>Search </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row-fluid sortable" ng-show="filelogCount != null">
                    <div className="box ws-12">
                        <div className="box-header well">
                            <h2> <i className="icon-info"></i> <span ng-bind="filelogCount + ' ' + 'record(s) found'" >{viewUploadLog.length} record(s) found</span>  </h2>
                        </div>
                        <div className="box-content">
                            <div className="alert alert-info  ng-hide" data-ng-show="filelogCount == 0">No records to display</div>
                            <div className="table-responsive">
                                <table className="table" data-ng-show="filelogCount &gt; 0">
                                    <thead>
                                        <tr>
                                            <th >File</th>
                                            <th >Status</th>
                                            <th >Template</th>
                                            <th >Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr ng-repeat="fileLog in filelog" ng-className="fileLog.status == 100 ? 'success' : (fileLog.status == 0 ? 'info' : 'danger')" className=" info">
                                            <td><a href="javascript:void(0)" ng-click="downloadFileLog(fileLog.originalFileName);" title="Click to download file" >SuggestedPayments.zip (spy_stagingnew_20250718_042654.zip) </a></td>
                                            <td ng-bind="fileLog.description" >Post ingestion script execution</td>
                                            <td ng-bind="fileLog.tempIds" >tmpSugPay01</td>
                                            <td>
                                                <a ng-click="fileLogProgress(fileLog)" className="btn-sm icon-btn primary"><i className="icon-info"></i></a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="clearfix">

                            </div>
                        </div>

                    </div>

                </div>
                <div className="box-footer">
                    <button className="btn icon-btn delete " data-ng-click="closeFileLogPopup()"><i className="icon-close"></i>Close</button>
                </div>

            </Modal>

        </div>
    )
}